import Cookies from "js-cookie";
import React, { useState } from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useNavigate } from "react-router";
import flowchangerLogo from "../../../../Assets/Images/flowchangerAINew.jpeg";
import { useAuthContext } from "../../../../Context/AuthContext";
import { useGlobalContext } from "../../../../Context/GlobalContext";
import loginLady from "../../../../Assets/Images/login-lady.png";
import loginSlash from "../../../../Assets/Images/login-slash.jpeg";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
const ConfirmPassword = () => {
  const { profile } = useAuthContext();
  const { setIsAuthenticated, setStep } = useAuthContext();
  const [showPassword, setShowPassword] = useState(false);

  const { openToast, baseUrl } = useGlobalContext();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);
  const [password, setPassword] = React.useState("");
  const handleLoggedIn = async (loginInfo) => {
    console.log(loginInfo);
    try {
      const response = await fetch(baseUrl + "user/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginInfo),
      });
      console.log(response);
      const result = await response.json();
      console.log(result, "sjdfoijaskdjfhih");
      if (response.status === 403) {
        alert("403");
        openToast(result.message || "Login failed", "error");
        const email = loginInfo.email;
        console.log("navigate to step3", email);
        setStep(3);
        navigate(`/authentication?step=3&email=${encodeURIComponent(email)}`);
      } else if (response.status === 200) {
        openToast("You have successfully logged in", "success");
        console.log("You have logged in");

        const {
          token,
          user: { role },
        } = result;

        Cookies.set("flowChangerAuthToken", token);
        setIsAuthenticated(true);
        role === "CLIENT" ? navigate("/c") : navigate("/");
        return true;
      } else {
        console.log("there is no token");
        openToast(result.message || "Login failed", "error");
        console.log("can't logged in");
        return false;
      }
    } catch (error) {
      console.error("Login error:", error);
      openToast("An error occurred. Please try again.", "error");
      return false;
    }
  };

  const onSubmit = async () => {
    setIsLoading(true);
    try {
      const LoginInfo = {
        email: profile.email.toLowerCase(),
        password: password,
      };
      const success = await handleLoggedIn(LoginInfo);
      if (success) {
        console.log("Login successful and user authenticated");
        openToast("Welcome To Dashboard");
      }
    } catch (error) {
      console.error("Login error:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="relative flex flex-start mt-9 ml-9">
        <MdKeyboardArrowLeft className="top-3 left-4 absolute inset-y-0 mr-5 text-white" />
        <button
          className="bg-[#8a25b0] hover:bg-[#a515db] px-9 py-2 rounded-full text-white"
          onClick={() => navigate(-1)}
        >
          Back
        </button>
      </div>
      <div className="flex justify-center items-center px-[10px] md:px-[20px] lg:px-[10px] xl:px-[10px] py-[0px] md:py-[20px] lg:py-[20px] xl:py-[20px] h-lvh min-h-screen overflow-y-auto">
        <div className="flex justify-center bg-white rounded-lg w-[100%] lg:w-[100%] xl:w-[80%] h-[350px] login-div">
          <div className="w-[100%] md:w-[50%] lg:w-[50%] xl:w-[50%]">
            <div className="space-y-2 sm:space-y-0 lg:px-[62px] xl:px-[30px] py-[40px] md:p-[30px] w-full h-[100%]">
              <div className="flex justify-center font-bold text-4xl text-white">
                <img
                  src={flowchangerLogo}
                  alt="Flowchangers Logo"
                  className="h-[70px]"
                />
              </div>
              <div className="">
                <div className="flex flex-col justify-center items-center gap-y-0">
                  <h2 className="mt-[10px] mb-[10px] text-[#8c8c8c] text-[16px] text-center">
                    Confirm Your Password
                  </h2>
                </div>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    onSubmit();
                  }}
                >
                  <div className="relative mb-6">
                    <input
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      type={showPassword ? "text" : "password"}
                      placeholder="Confirm your password"
                      aria-label="password"
                      className="login-input-field"
                    />

                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="top-[4px] right-[13px] absolute"
                    >
                      {showPassword ? (
                        <VisibilityIcon className="top-[7px] right-[0px] absolute text-[#8a25b0] email-icon" />
                      ) : (
                        <VisibilityOffIcon className="top-[7px] right-[0px] absolute text-[#8a25b0] email-icon" />
                      )}
                    </button>
                  </div>
                  <button
                    type="submit"
                    className={
                      " font-medium text-[#fff] text-center free-signup  bg-[#8a25b0] border-[#8a25b1]  rounded-full border w-full  py-[8px] px-4 false" +
                      (isLoading &&
                        "disabled:animate-pulse disabled:cursor-not-allowed")
                    }
                  >
                    Submit password
                  </button>
                </form>
              </div>
            </div>
          </div>

          <div className="relative login-right md:flex justify-center items-center hidden bg-[#9181F4] px-[30px] py-[10px] w-[50%] md:w-[50%] lg:w-[50%] xl:w-[50%] text-4xl text-center">
            <div className="relative border-[#bfbfbf66] bg-[#e2e0e938] border rounded-xl w-[80%] h-[83%]">
              <h2 className="p-[18px] w-[212px] font-bold text-[32px] text-left text-white md:text-[22px]">
                Very good works are waiting for you Login Now!!!
              </h2>
              <div className="top-[-6px] right-[-42px] bottom-[0px] absolute">
                <img src={loginLady} alt="loginLady" className="h-[100%]" />
              </div>
              <div className="left-[-20px] absolute bg-white p-[10px] rounded-full">
                <img
                  src={loginSlash}
                  alt="loginSlash"
                  className="rounded-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmPassword;
